import React, { Component } from 'react';
import { Menu, Icon, Label } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { setPrivateChannel, setCurrentChannel } from '../../actions';
import firebase from '../../firebase';

class Starred extends Component {
	state = {
		user: this.props.currentUser,
		usersRef: firebase.database().ref('users'),
		starredChannels: [],
		activeChannel: '',
	};

	componentDidMount() {
		if (this.state.user) {
			this.addListeners(this.state.user.uid);
		}
	}

	addListeners = (userId) => {
		this.state.usersRef
			.child(userId)
			.child('starred')
			.on('child_added', (snap) => {
				const starredChannel = {
					id: snap.key,
					...snap.val(),
				};
				this.setState({
					starredChannels: [...this.state.starredChannels, starredChannel],
				});
			});

		this.state.usersRef
			.child(userId)
			.child('starred')
			.on('child_removed', (snap) => {
				const channelToBeRemoved = { id: snap.key, ...snap.val() };
				const filteredChannels = this.state.starredChannels.filter(
					(channel) => channel.id !== channelToBeRemoved.id
				);
				this.setState({
					starredChannels: filteredChannels,
				});
			});
	};

	setActiveChannel = (channel) => {
		this.setState({
			activeChannel: channel.id,
		});
	};

	changeChannel = (channel) => {
		this.setActiveChannel(channel);
		this.props.setCurrentChannel(channel);
		this.props.setPrivateChannel(false);
	};

	displayChannels = (starredChannels) =>
		starredChannels.length > 0 &&
		starredChannels.map((channel) => (
			<Menu.Item
				key={channel.id}
				onClick={() => this.changeChannel(channel)}
				name={channel.name}
				style={{ opacity: 0.7 }}
				active={channel.id === this.state.activeChannel}
			>
				{/* {this.getNotificationCount(channel) && (
					<Label color='red'>{this.getNotificationCount(channel)}</Label>
				)} */}
				#{channel.name}
			</Menu.Item>
		));

	render() {
		const { starredChannels } = this.state;
		return (
			<Menu.Menu className='menu'>
				<Menu.Item>
					<span>
						<Icon name='star' />
						STARRED
					</span>{' '}
					({starredChannels.length})
				</Menu.Item>
				{/* Channels */}
				{this.displayChannels(starredChannels)}
			</Menu.Menu>
		);
	}
}

export default connect(null, { setPrivateChannel, setCurrentChannel })(Starred);



// WEBPACK FOOTER //
// ./src/components/SidePanel/Starred.js